import { type ReactElement } from 'react';
import {
  RiBarcodeBoxLine,
  RiCalendarCheckFill,
  RiCalendarScheduleFill,
  RiFlagFill,
  RiPriceTag3Fill,
  RiSyringeFill,
  RiChat3Fill,
  RiTestTubeFill,
  RiTimerLine,
} from 'react-icons/ri';
import { TbMathFunction, TbRuler, TbScale } from 'react-icons/tb';
import type { DataTableColumnType } from '@/components/UI/DataTableV2/DataTable.model';

interface DataTableColumnTypeIconProps {
  type: DataTableColumnType;
}

export function DataTableColumnTypeIcon({ type }: DataTableColumnTypeIconProps): ReactElement {
  switch (type) {
    case 'number':
      return <span>#</span>;
    case 'text':
      return <span>☰</span>;
    case 'timestamp':
    case 'timestampBaseline':
    case 'timestampBaselineRelative':
      return <RiTimerLine size={12} />;
    case 'formula':
      return <TbMathFunction size={12} />;
    case 'measurement':
      return <TbRuler size={12} />;
    case 'observation':
      return <TbScale size={12} />;
    case 'sample':
    case 'sampleDetail':
      return <RiTestTubeFill size={12} />;
    case 'sampleId':
      return <RiBarcodeBoxLine size={12} />;
    case 'sampleStatus':
      return <RiFlagFill size={12} />;
    case 'sampleCollectedAt':
      return <RiCalendarCheckFill size={12} />;
    case 'samplePlannedAt':
      return <RiCalendarScheduleFill size={12} />;
    case 'sampleDoseTime':
      return <RiSyringeFill size={12} />;
    case 'sampleComments':
      return <RiChat3Fill size={12} />;
    case 'metadata':
      return <RiPriceTag3Fill size={12} />;
  }
}
